import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from "./FirebaseAuthContext";

const PrivateRoute = ({ children }) => {
    const auth = useAuth();
    return auth.user !== null ? children : <Navigate to="/login" />;
}

export default PrivateRoute;
